import axios from "axios";
import {
  getHeader,
  handleResponse,
  handleGoResponse,
  getApiUrl,
  getGoApiUrl,
} from "./http.header";
var source = {};

const getActualBaseUrl = function (url, baseUrl) {
  var urlArr = url.split("/");
  if (urlArr[0] && urlArr[0] === "panel") {
    baseUrl = getGoApiUrl();
  } else if (!baseUrl) {
    baseUrl = getApiUrl();
  }
  return baseUrl;
};

const getHandleAllResponse = function (url) {
  if (url.indexOf("panel/") > -1) {
    return handleGoResponse;
  }
  return handleResponse;
};

export default {
  get(url, exportname, baseUrl) {
    // if (!baseUrl) {
    //   baseUrl = getApiUrl()
    // }
    baseUrl = getActualBaseUrl(url, baseUrl);
    const handleAllResponse = getHandleAllResponse(url);
    return new Promise(function (resolve, reject) {
      var response = axios.get(baseUrl + url, { headers: getHeader() });
      handleAllResponse(response, exportname, function (error, data) {
        if (error) {
          reject(data);
        } else {
          resolve(data);
        }
      });
    });
  },
  post(url, data, exportname, baseUrl, key = "") {
    // if (!baseUrl) {
    //   baseUrl = getApiUrl()
    // }
    const handleAllResponse = getHandleAllResponse(url);
    baseUrl = getActualBaseUrl(url, baseUrl);
    var options = { headers: getHeader() };
    return new Promise(function (resolve, reject) {
      if (source[url + key]) {
        source[url + key].cancel("canceled");
      }
      var CancelToken = axios.CancelToken;
      source[url + key] = CancelToken.source();
      options.cancelToken = source[url + key].token;
      var response = axios.post(baseUrl + url, data, options);
      handleAllResponse(response, exportname, function (error, data) {
        if (source[url + key]) {
          delete source[url + key];
        }
        if (error) {
          reject(data);
        } else {
          resolve(data);
        }
      });
    });
  },
  patch(url, data, exportname, baseUrl) {
    // if (!baseUrl) {
    //   baseUrl = getApiUrl()
    // }
    const handleAllResponse = getHandleAllResponse(url);
    baseUrl = getActualBaseUrl(url, baseUrl);
    var options = { headers: getHeader() };
    return new Promise(function (resolve, reject) {
      if (source[url]) {
        source[url].cancel("canceled");
      }
      var CancelToken = axios.CancelToken;
      source[url] = CancelToken.source();
      options.cancelToken = source[url].token;
      var response = axios.patch(baseUrl + url, data, options);
      handleAllResponse(response, exportname, function (error, data) {
        if (source[url]) {
          delete source[url];
        }
        if (error) {
          reject(data);
        } else {
          resolve(data);
        }
      });
    });
  },
  put(url, data, baseUrl) {
    // if (!baseUrl) {
    //   baseUrl = getApiUrl()
    // }
    baseUrl = getActualBaseUrl(url, baseUrl);
    const handleAllResponse = getHandleAllResponse(url);
    return new Promise(function (resolve, reject) {
      const response = axios.put(baseUrl + url, data, { headers: getHeader() });
      handleAllResponse(response, "", function (error, data) {
        if (error) {
          reject(data);
        } else {
          resolve(data);
        }
      });
    });
  },
  deleteRecord(url) {
    var baseUrl = getApiUrl();
    baseUrl = getActualBaseUrl(url, baseUrl);
    const handleAllResponse = getHandleAllResponse(url);
    var options = { headers: getHeader() };
    return new Promise(function (resolve, reject) {
      var response = axios.delete(baseUrl + url, options);
      handleAllResponse(response, "", function (error, data) {
        if (error) {
          reject(data);
        } else {
          resolve(data);
        }
      });
    });
  },
  downLoad(url, data) {
    var baseUrl = getApiUrl();
    var response = axios.post(baseUrl + url, data, { headers: getHeader() });
    return response;
  },
  /*deleteRecord(url) {
    var baseUrl = getApiUrl();
    baseUrl = getActualBaseUrl(url, baseUrl);
    var options = { headers: getHeader() };
    const handleAllResponse = getHandleAllResponse(url);
    return new Promise(function (resolve, reject) {
      var response = axios.delete(baseUrl + url, options);
      handleAllResponse(response, "", function (error, data) {
        if (error) {
          reject(data);
        } else {
          resolve(data);
        }
      });
    });
  },
  put(url, data, baseUrl) {
    const handleAllResponse = getHandleAllResponse(url);
    baseUrl = getActualBaseUrl(url, baseUrl);
    return new Promise(function (resolve, reject) {
      const response = axios.put(baseUrl + url, data, { headers: getHeader() });
      handleAllResponse(response, "", function (error, data) {
        if (error) {
          reject(data);
        } else {
          resolve(data);
        }
      });
    });
  },
  patch(url, data, baseUrl) {
    const handleAllResponse = getHandleAllResponse(url);
    baseUrl = getActualBaseUrl(url, baseUrl);
    return new Promise(function (resolve, reject) {
      const response = axios.patch(baseUrl + url, data, {
        headers: getHeader(),
      });
      handleAllResponse(response, "", function (error, data) {
        if (error) {
          reject(data);
        } else {
          resolve(data);
        }
      });
    });
  },*/
};
